import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d82fd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}

import { withDefaults, watch } from 'vue';
import { MoleculeCard } from '@/components/molecules';
import VueHighcharts from 'vue3-highcharts';
import HighCharts from 'highcharts';
import MapCharts from 'highcharts/modules/map';
import brMap from '@highcharts/map-collection/countries/br/br-all.geo.json';
import { IDataMapChart, IOptionsSelect, IToggleButon } from '@/types';

interface IProps {
  title: string;
  legend: boolean;
  data: Array<IDataMapChart>;
  name?: string;
  colorHover?: string;
  colorLabel?: string;
  height?: number;
  hasToggle?: boolean;
  buttons?: IToggleButon[];
  hasDropdownList?: boolean;
  optionsDropDown?: IOptionsSelect[];
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsMapCharts',
  props: {
    title: { default: '' },
    legend: { type: Boolean, default: false },
    data: {},
    name: {},
    colorHover: {},
    colorLabel: {},
    height: {},
    hasToggle: { type: Boolean },
    buttons: {},
    hasDropdownList: { type: Boolean },
    optionsDropDown: {},
    loading: { type: Boolean, default: false }
  },
  emits: ['handleToggle', 'onChangeDropDownList'],
  setup(__props: any, { emit: __emit }) {

MapCharts(HighCharts);

const props = __props;
const emit = __emit;
let values = props.data.map((f) => {
  return [`br-${f.uf.toLowerCase()}`, f.value];
});

let chartOptions = {};
changeChartOptions();
function changeChartOptions() {
  values = props.data.map((f) => {
    return [`br-${f.uf.toLowerCase()}`, f.value];
  });
  chartOptions = {
    chart: {
      map: brMap,
      legend: true,
      height: props.height,
    },
    legend: {
      enabled: props.legend,
    },

    title: {
      text: '',
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom',
      },
    },

    series: [
      {
        name: props.name,
        data: [...values],
        color: props.colorLabel,
        states: {
          hover: props.colorHover
            ? {
              color: props.colorHover,
            }
            : undefined,
        },
        dataLabels: {
          enabled: true,
          color: props.colorLabel,
          // format: '',
        },
      },
    ],
  };
}
function handleToogleChange($event) {
  emit('handleToggle', $event);
}
function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}

watch(
  () => props.data,
  () => {
    changeChartOptions();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_AtomToogleButton = _resolveComponent("AtomToogleButton")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    textTooltip: 'textTooltip',
    title: props.title,
    onOnChangeDropDownList: handleChangeDropdownList,
    "has-dropdown-list": props.hasDropdownList,
    "options-drop-down": props.optionsDropDown,
    loading: props.loading
  }, {
    default: _withCtx(() => [
      (props.hasToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_AtomToogleButton, {
              buttons: props.buttons ?? [],
              onHandleToggle: handleToogleChange
            }, null, 8, ["buttons"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(VueHighcharts), {
        type: "mapChart",
        options: _unref(chartOptions),
        redrawOnUpdate: true,
        oneToOneUpdate: false,
        animateOnUpdate: true
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["title", "has-dropdown-list", "options-drop-down", "loading"]))
}
}

})